<template>
    <div v-if="qrCode.product.allows_image && qrCode.image" class="qr-code-with-image w-56 mx-auto">
        <div v-if="useCroppedImage && qrCode.image_cropped" class="image-masked">
            <img :src="qrCode.image_cropped.file" alt="" class="relative"/>
        </div>
        <div v-else id="cropper-preview" class="cropper-initial"/>

        <div
            class="qr-code mx-auto bg-black relative z-10 rounded-lg rounded-t-none border-gray-400 border-t-0 border-4"
            :class="useCroppedImage ? '-mt-[25px]' : '-mt-[22px]'"
        >
            <img class="mx-auto invert" :src="qrCode.qr_image" alt=""/>
        </div>
    </div>
    <div v-else class="w-56 mx-auto rounded-lg border-gray-400 border-4 bg-black">
        <img class="mx-auto invert" :src="qrCode.qr_image" alt=""/>
    </div>
</template>

<script setup>
import { onMounted } from "vue";

const props = defineProps({
    qrCode: Object,
    useCroppedImage: Boolean,
});

const emit = defineEmits(['loaded']);

onMounted(() => emit('loaded'));
</script>

<style>
#cropper-preview {
    margin-left: 4px;
}

.image-masked {
    margin-left: 4px;
}

.cropper-initial img {
    position: relative;
    top: 1px;
    left: 1px;
    height: 233px !important;
}

.image-masked, #cropper-preview {
    overflow: hidden;
    height: 233px;
    width: 216px;
}

.image-masked, #cropper-preview img {
    mask-image: url("/img/qr-image-mask.svg");
    filter: grayscale(100%);
    object-fit: cover;
    mask-repeat: no-repeat;
}

.qr-code-with-image .qr-code {
    width: 129px;
}
</style>
